import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRainbow = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 640 512",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M320 80C169.8 80 48 201.8 48 352l0 72c0 13.3-10.7 24-24 24S0 437.3 0 424l0-72C0 175.3 143.3 32 320 32S640 175.3 640 352l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72C592 201.8 470.2 80 320 80zm0 112c-88.4 0-160 71.6-160 160l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-114.9 93.1-208 208-208s208 93.1 208 208l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-88.4-71.6-160-160-160zM272 352l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-53 43-96 96-96s96 43 96 96l0 72c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-72c0-26.5-21.5-48-48-48s-48 21.5-48 48z"
		})
	});
};
export default SvgRainbow;
